import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";

const HiddenValueOfRange = ({ range }) => {
    const hiddenValueRef = useRef(null);
    const [showHiddenValue, setShowHiddenValue] = useState(false);

    useEffect(() => {
        if (hiddenValueRef.current && hiddenValueRef.current.offsetWidth < 60) setShowHiddenValue(false);
        else setShowHiddenValue(true);
    }, [range]);

    return (
        range && <div className={showHiddenValue ? "hiddenValue" : "hiddenValue hide"} ref={hiddenValueRef}>{range.percent}<div>%</div></div>
    );
}

export default observer(HiddenValueOfRange);